<template>
  <img
    src="~/assets/icon/icon-phone-calling.svg"
    alt=""
  />
</template>
